import {logger} from 'yougile-util'
import {CrmActivitiesFilters} from '../common'

export const filterLocalStorageKey = 'crm-deal-view-filter'

export const getInitFiltersValue = (): CrmActivitiesFilters => {
  return {
    page: 'day',
    selectedDay: Date.now(),
    assigned: []
  }
}

export const loadFiltersFromLocalStorage = (
  setFilters: (filters: CrmActivitiesFilters) => void
): void => {
  try {
    const filter = localStorage.getItem(filterLocalStorageKey)
    if (filter) {
      setFilters(
        (JSON.parse(filter) as CrmActivitiesFilters) || getInitFiltersValue()
      )
    }
  } catch (error) {
    logger.error('Error loading filters from localStorage', error)
  }
}

export const saveFiltersToLocalStorage = (
  filters: CrmActivitiesFilters
): void => {
  try {
    localStorage.setItem(filterLocalStorageKey, JSON.stringify(filters))
  } catch (error) {
    logger.error('Error saving filters to localStorage', error)
  }
}
